module.exports = __webpack_public_path__ + "img/comic7.jpg";